import * as React from 'react';
import { TableCell, Tooltip, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

type Props = React.ComponentProps<typeof TableCell> & {
    tooltip?: React.ReactNode;
    withIcon?: boolean; // default: true
    iconPlacement?: 'start' | 'end';
    iconProps?: React.ComponentProps<typeof InfoOutlinedIcon>;
};

const TooltipTableCell = React.forwardRef<HTMLTableCellElement, Props>(
    ({ children, tooltip, withIcon = true, iconPlacement = 'end', iconProps, ...cellProps }, ref) => {
        if (!tooltip) {
            return (
                <TableCell ref={ref} {...cellProps}>
                    {children}
                </TableCell>
            );
        }

        const icon = (
            <Tooltip title={tooltip} arrow enterTouchDelay={0}>
                <HelpOutlineIcon
                    fontSize="small"
                    sx={{ color: 'action.active', verticalAlign: 'middle' }}
                    {...iconProps}
                />
            </Tooltip>
        );

        return (
            <TableCell ref={ref} {...cellProps}>
                {withIcon ? (
                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                        {iconPlacement === 'start' && icon}
                        <span>{children}</span>
                        {iconPlacement === 'end' && icon}
                    </Box>
                ) : (
                    <Tooltip title={tooltip} arrow enterTouchDelay={0}>
                        <span>{children}</span>
                    </Tooltip>
                )}
            </TableCell>
        );
    }
);

export default TooltipTableCell;
